import { Modal } from 'components'
import { ReactElement, useState } from 'react'
import { Typography } from '@mui/material'

interface Props {
  onConfirm(): void
}

const useAcceptStorageSolutionModal = ({
  onConfirm,
}: Props): [ReactElement, VoidFunction] => {
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const handleConfirm = () => {
    onConfirm()
    setIsOpen(false)
  }

  return [
    <Modal
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      title="Attention!"
      onConfirm={handleConfirm}
      onConfirmButtonText="Ok"
    >
      <Typography
        sx={{
          color: (theme) => theme.palette.text.secondary,
        }}
        fontSize={22}
        fontWeight="bold"
        maxWidth={380}
      >
        Are you sure you want to accept the Storage solution?
      </Typography>
    </Modal>,
    () => setIsOpen(!isOpen),
  ]
}

export default useAcceptStorageSolutionModal
